<template>
  <div>
    <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-success">
      <b-button variant="secondary" class="ml-2 mt-3" @click="$router.go(-1)">
        <i class="fas fa-arrow-left"></i> {{ $t('volver') }}
      </b-button>

      <b-container style="max-width: 90%; margin: auto;">
        <b-row>
          <b-col md="12" class="mt-4 mb-4">
            <div class="divisor">
              {{ $t('crear_nuevo_tipo_cambio') }}
            </div>
          </b-col>
        </b-row>

        <b-form @submit.prevent="submitForm">
          <b-row>
            <b-col md="3">
              <b-form-group label-for="fecha">
                <template v-slot:label>
                  {{ $t('fecha') }} <span class="text-danger">*</span>
                </template>
                <b-form-input id="fecha" type="date" v-model="form.fecha" required></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>

          <h4 class="text-white mt-2 mb-2">{{ $t('paridades_clp') }}</h4>
          <b-row>
            <b-col md="2" v-for="col in obligatorias" :key="col.key">
              <b-form-group :label-for="col.key">
                <template v-slot:label>
                  {{ col.label }} <span class="text-danger">*</span>
                </template>
                <b-form-input :id="col.key" type="number" step="0.000001" min="0"
                  v-model="form[col.key]" required :placeholder="col.label"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>

          <h4 class="text-white mt-2 mb-2">{{ $t('paridades_cruzadas') }}</h4>
          <b-row>
            <b-col md="2" v-for="col in opcionales" :key="col.key">
              <b-form-group :label="col.label" :label-for="col.key">
                <b-form-input :id="col.key" type="number" step="0.000001" min="0"
                  v-model="form[col.key]" :placeholder="col.label"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>

          <b-button type="submit" variant="primary">
            {{ $t('guardar') }}
          </b-button>
        </b-form>
      </b-container>
    </base-header>
  </div>
</template>

<script>
import tipoCambioService from '@/api/tipoCambioService';
import Swal from 'sweetalert2';

export default {
  name: 'TipoCambioCrear',
  data() {
    return {
      // clpClp no se pide en el formulario: es la paridad de CLP contra si mismo (1).
      form: {
        fecha: new Date().toISOString().slice(0, 10),
        clpClp: 1,
        usdClp: '',
        eurClp: '',
        arsClp: '',
        copClp: '',
        penClp: '',
        audClp: '',
        usdArs: '',
        usdCop: '',
        usdPen: '',
        audUsd: '',
        eurUsd: '',
      },
      obligatorias: [
        { key: 'usdClp', label: 'USD/CLP' },
        { key: 'eurClp', label: 'EUR/CLP' },
        { key: 'arsClp', label: 'ARS/CLP' },
        { key: 'copClp', label: 'COP/CLP' },
        { key: 'penClp', label: 'PEN/CLP' },
        { key: 'audClp', label: 'AUD/CLP' },
      ],
      opcionales: [
        { key: 'usdArs', label: 'USD/ARS' },
        { key: 'usdCop', label: 'USD/COP' },
        { key: 'usdPen', label: 'USD/PEN' },
        { key: 'audUsd', label: 'AUD/USD' },
        { key: 'eurUsd', label: 'EUR/USD' },
      ],
    };
  },
  methods: {
    submitForm() {
      Swal.fire({
        title: this.$t('esta_seguro'),
        text: this.$t('revisa_datos'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('crear_tipo_cambio'),
        cancelButtonText: this.$t('cancelar'),
      }).then(async (result) => {
        if (!result.isConfirmed) {
          Swal.close();
          return;
        }

        try {
          Swal.fire({
            html: '<div style="display:flex;align-items:center;justify-content:center;">' +
                  '<img src="/img/others/loading.gif" alt="Loading" style="width:50px;height:50px;margin-right:15px;">' +
                  '<div><h3 style="color:#006393;">' + this.$t('creando') + '</h3></div>' +
                  '</div>',
            showConfirmButton: false,
            allowOutsideClick: false,
          });

          const response = await tipoCambioService.create(this.form);

          if (!response || !response.data) {
            Swal.fire({ icon: 'error', title: 'Oops...', text: 'Ocurrió un error inesperado.' });
            return;
          }

          Swal.fire({
            title: this.$t('creado_correctamente'),
            icon: 'success',
            showConfirmButton: false,
            timer: 2000,
          });

          this.$router.push({ name: 'tipo-cambio-detalle', params: { fecha: String(this.form.fecha).substring(0, 10) } });
        } catch (error) {
          const raw = (error && error.response) ? error.response.data : error;

          let status = 0;
          if (error && error.response && typeof error.response.status !== 'undefined') {
            status = error.response.status;
          }

          let msg = 'Error';
          if (typeof raw === 'string') {
            msg = raw;
          } else if (raw && (raw.message || raw.Message || raw.error || raw.title || raw.detail)) {
            msg = String(raw.message || raw.Message || raw.error || raw.title || raw.detail);
          } else if (error && error.message) {
            msg = error.message;
          } else {
            try { msg = JSON.stringify(raw, null, 2); } catch (e) { msg = 'Error'; }
          }

          const title = (status === 400 || status === 409) ? this.$t('datos_invalidos') : 'Oops...';
          const icon  = (status === 400 || status === 409) ? 'warning' : 'error';

          Swal.fire({
            icon: icon,
            title: title,
            html: '<pre style="font-family: inherit;text-align:center;white-space:pre-wrap;margin:0">' + msg + '</pre>',
          });
        }
      });
    },
  },
};
</script>

<style scoped>
.divisor {
  font-size: 16px;
  font-weight: 400;
  color: #fff;
  padding: 15px;
  background: #6172e9;
  border-radius: 10px;
}
</style>
